import React from 'react'
import { Modal } from 'antd'
import PropTypes from 'prop-types'
import styles from 'view/component/about/index.scss'

const CookiePolicy = ({ isModalVisible, handleClose, handleOpen }) => {
  return (
    <Modal
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
      className={styles.aboutModal}
      okText='Close'
      onCancel={handleClose}
      onOk={handleClose}
      open={isModalVisible}
      styles={{ paddingLeft: '10px' }}
      title='Cookie Policy'
      width={800}
    >
      <div className='p-3 about-scrollable'>
        <p>How we use cookies to improve your browsing experience on this website.</p>
        <p>In this Cookies Policy, any use of the words &quot;you&quot;, &quot;yours&quot; or similar expressions shall mean any user of this website whatsoever. Terms such as &quot;we&quot;, &quot;us, &quot;our&quot; or similar expressions shall mean the Football Association Premier League Limited.</p>
        <p>Cookies are small pieces of information that are stored by your browser on your computer’s hard drive. They are often used as a mechanism for websites to remember useful information, such as your login details, and can contribute to ease of use when navigating a website. Our cookies cannot identify you personally.</p><br />

        <h2>HOW WE USE COOKIES</h2>
        <p>Cookies on our website are used for a variety of different purposes, but generally speaking their use breaks down into the following categories:</p><br />
        <p>a)    Strictly Necessary Cookies: These are required for the operation of our website. They include, for example, cookies that enable you to log into secure areas of our website.</p><br />
        <p>b)    Analytical/Performance Cookies: These allow us to recognise and count the number of users of our website and see how such users navigate through our website. This helps to improve how our website works, for example, by ensuring that users can find what they are looking for easily.</p><br />
        <h2>MANAGING COOKIES</h2>
        <h2>Essential Cookies</h2>
        <p>Essential cookies are required for the operation of our website. You may disable these using your internet browser but this may affect website functionality.</p><br />
        <table className='m-2 border border-dark'>
          <tr className='border border-dark'>
            <th className='border border-dark'>Cookie Name</th>
            <th className='border border-dark'>Purpose</th>
          </tr>
          <tr className='border border-dark'>
            <td className='border border-dark'>X-Qlik-Session-qlikauthenticate</td>
            <td className='border border-dark'>This cookie is a reference to a unique session for Qlik. This allows dashboards and visualizations to be displayed.</td>
          </tr>
          <tr className='border border-dark'>
            <td className='border border-dark'>session</td>
            <td className='border border-dark'>This cookie is a reference to a unique session for a current browsing session. No personal data is stored in it. The session is ended when a user’s browser is closed.</td>
          </tr>
        </table><br />
        <h2>Non-essential Cookies</h2>
        <p>Non-essential cookies are set by premierleague.com. They help us improve the functionality of our website by collecting information and reporting on your use of the website as well as improving your user experience.</p><br />
        <table className=' m-2 border border-dark'>
          <tr className='border border-dark'>
            <th className='border border-dark'>Cookie Name</th>
            <th className='border border-dark'>Purpose</th>
          </tr>
          <tr className='border border-dark'>
            <td className='border border-dark'>_ga</td>
            <td className='border border-dark'>These cookies enable us to anonymously track how visitors access and browse our website, thereby enabling us to optimise and improve our service. Further information is available at: www.google.co.uk/intl/en/analytics/privacyoverview.html</td>
          </tr>
          <tr className='border border-dark'>
            <td className='border border-dark'>_gid</td>
            <td className='border border-dark'>This cookie is associated with Google Universal Analytics and is used to compile statistical reports which help us to improve our website.</td>
          </tr>
          <tr className='border border-dark'>
            <td className='border border-dark'>__gads</td>
            <td className='border border-dark'>These cookies enable us to anonymously track how visitors access and browse our website, thereby enabling us to optimise and improve our service. Further information is available at: www.google.co.uk/intl/en/analytics/privacyoverview.html</td>
          </tr>
        </table><br />

        <h2>CHANGES TO THIS COOKIES POLICY</h2>
        <p>Our policies and procedures are under continual review. We may, from time to time, update our cookies policy. Any such changes will be posted on this page.</p>
      </div>
    </Modal>)
}

CookiePolicy.propTypes = {
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
  isModalVisible: PropTypes.bool
}

export default CookiePolicy
